// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"361decb0","350":"38c28edb","453":"9cd3def4","732":"d6300edd","943":"fae5818f"}[chunkId] + ".chunk.js";
};